
import Vue from "vue";
import { deselectAllFilters, toggleFilter } from "../store/actions";
import { ISearchHit, ITemplateFilter, ITranslations } from "../store/state";

interface SelectedFiltersComputed {
  selectedFilters: ITemplateFilter;
  translations: ITranslations;
}
interface SelectedFiltersMethods {
  deselectFilter(id: string): void;
  deselectAllFilters(): void;
}

export default Vue.extend<
  {},
  SelectedFiltersMethods,
  SelectedFiltersComputed,
  {}
>({
  name: "SelectedFilters",
  computed: {
    selectedFilters() {
      return this.$store.getters.templateFilter.filter(
        (f: ITemplateFilter) => f.selected
      );
    },
    translations() {
      return this.$store.getters.translations;
    },
  },
  methods: {
    deselectFilter(id) {
      this.$store.dispatch(
        toggleFilter({
          id: id,
          value: false,
        })
      );
    },
    deselectAllFilters() {
      this.$store.dispatch(deselectAllFilters(undefined));
    },
  },
});
